import { UPDATERESOURCESREQUEST, UPDATERESOURCESSUCCESS, UPDATERESOURCESERROR} from '../actions/actionTypes';

const initialState = {
    isFetching : false,
    err : false,
    isFetched : false,
    message : ''
  };

  // receiving response sent by action according to type of action
export default function updateResourceReducer(state = initialState, action) {
    //console.log(action,'action')
  switch (action.type) {
    case UPDATERESOURCESREQUEST:
      return { 
          isFetching : true,
          err : false,
          isFetched : false,
          message : 'fetching...'
      };
      break;

    case UPDATERESOURCESSUCCESS:
      return { 
          isFetching : false,
          err : false,
          isFetched : true,
          message : action.payload.message
          
        };
        break;
        
    case UPDATERESOURCESERROR:
        return { 
            isFetching : false,
            err : true,
            isFetched : false,
            message : action.payload.message
        };
      break;
    
    default:
      return state;
  }
}  